const TABLE_ROW_HIGHLIGHT_STYLES = {
  EXCLUDED: '#a3a3a3',
  LOW_CERTAINTY: '#fff5e6',
  REQUIRES_ATTENTION: '#eaff8f',
  IGNORED: '#a3a3a3',
  ERROR: '#d3adf7',
  LIKELY_TO_BE_WRONG: '#ffd6e7',
  LOCKED: '#839e0b',
}

export default TABLE_ROW_HIGHLIGHT_STYLES
